import React from 'react';

const DownloadResume = () => {
    console.log('what can i do');
    alert('asd')
    return (
        <div>
            this is a sample text
        </div>
    );
};

export default DownloadResume;